import { useState, useEffect } from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { api, getToken, clearTokens, getRefreshToken } from "./api.js";
import { Sidebar } from "./components/sidebar.js";
import { TooltipProvider } from "./components/ui/tooltip.js";
import LoginPage from "./pages/Login.js";
import RegisterPage from "./pages/Register.js";
import DashboardPage from "./pages/Dashboard.js";
import EmitirPage from "./pages/Emitir.js";
import EmitidosPage from "./pages/Emitidos.js";
import SuscripcionPage from "./pages/Suscripcion.js";
import ClientesPage from "./pages/Clientes.js";
import AdminPage from "./pages/Admin.js";
import SeguridadPage from "./pages/Seguridad.js";
import MockupAccionesPage from "./pages/MockupAcciones.js";

export default function App() {
  const [authed, setAuthed] = useState(!!getToken());
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [userNombre, setUserNombre] = useState<string | null>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [authMode, setAuthMode] = useState<"login" | "register">("login");

  useEffect(() => {
    if (!authed) return;
    api<{ email?: string; nombre?: string; role?: string }>("/auth/me")
      .then((res) => {
        setUserEmail(res.email ?? null);
        setUserNombre(res.nombre ?? null);
        setUserRole(res.role ?? null);
      })
      .catch(() => {});
    api("/health").catch(() => {
      setAuthed(false);
      clearTokens();
    });
  }, [authed]);

  const handleLogout = () => {
    const refreshToken = getRefreshToken();
    if (refreshToken) {
      api("/auth/logout", {
        method: "POST",
        body: JSON.stringify({ refreshToken }),
      }).catch(() => {});
    }
    clearTokens();
    setAuthed(false);
    setUserEmail(null);
    setUserNombre(null);
    setUserRole(null);
  };

  if (!authed) {
    return (
      <>
        {authMode === "login" ? (
          <LoginPage
            onLogin={() => setAuthed(true)}
            onRegister={() => setAuthMode("register")}
          />
        ) : (
          <RegisterPage
            onRegister={() => setAuthed(true)}
            onBack={() => setAuthMode("login")}
          />
        )}
        <Toaster richColors position="top-right" />
      </>
    );
  }

  return (
    <TooltipProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Sidebar onLogout={handleLogout} userEmail={userEmail} userRole={userRole} />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage onError={() => {}} />} />
            <Route path="emitir" element={<EmitirPage />} />
            <Route path="documentos" element={<EmitidosPage />} />
            <Route path="emitidos" element={<EmitidosPage />} />
            <Route path="clientes" element={<ClientesPage />} />
            <Route path="suscripcion" element={<SuscripcionPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="seguridad" element={<SeguridadPage />} />
            <Route path="mockup-acciones" element={<MockupAccionesPage />} />
          </Route>
        </Routes>
      </HashRouter>
      <Toaster richColors position="top-right" />
    </TooltipProvider>
  );
}
